import { BlogCard } from './types';

export const sexualHealthBlogCards: BlogCard[] = [
  {
    title: {
      content:
        '### Your Trusted Sexual Health Clinic: More Than Just Testing and Treatment',
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 my-3 text-base md:text-lg leading-tight line-clamp-2',
      },
      topicsStyles: {
        h3: 'text-theme-primary text-3xl md:text-4xl my-4 md:my-6 p-2 font-black',
      },
    },
    description: {
      content:
        'At LIPS Clinic, located at Battersea Power Station, we strive to ensure that sexual health is not only about the testing and...',
      styles: {
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
      },
    },
    imageUrl: 'sexual-health-banner.webp',
    bannerUrl: 'sexual-health-banner.webp',
    slug: 'your-trusted-sexual-health-clinic-more-than-just-testing-and-treatment',
    contentType: 'article',
    doctorSlug: 'fareed-shiva',
    tableOfContents: {
      heading: {
        content: '### TABLE OF CONTENTS:',
        styles: {
          h3: 'font-Mulish font-bold text-royal-875 mb-3 text-lg md:text-xl',
        },
      },
      content: [
        { text: 'More Than Test and Treat', id: 'more-than-test' },
        { text: 'HIV Testing, Treatment, and U=U', id: 'hiv-testing' },
        { text: 'STI Prevention and Vaccinations', id: 'sti-prevention' },
        {
          text: 'Saturday Clinic: Accessible Care for Everyone',
          id: 'saturday-clinic',
        },
      ],
      styles: {
        p: 'text-lg text-teal-500 underline leading-snug text-left cursor-pointer font-semibold',
      },
    },
    topics: {
      title: {
        content: '#### TOPICS:',
        styles: {
          h4: 'text-theme-primary font-extrabold p-2',
        },
      },
      topics: ['STI', 'HIV testing & treatment'],
      styles: {
        p: 'p-2 bg-info-500-opac-10 text-teal-450 bg-info-500-soft',
      },
    },
    speciality: 'Sexual Health',
    date: {
      content: '8, May 2025',
      iconUrl: '/images/blogs/calendar.svg',
      styles: {
        p: 'text-gray-500 text-xs',
      },
    },
    author: {
      content: 'Dr Fareed Shiva',
      styles: {
        p: 'text-indigo-650 font-bold text-xs',
        h3: 'text-theme-primary font-black text-2xl md:text-4xl',
      },
    },
    postimonial: {
      content:
        'MD, MSc, DTM&H, MRCP, DipGUM, DipHIV, DFSRH\nConsultant Sexual Health, HIV and Contraception',
      styles: {
        p: 'text-base md:text-xl whitespace-pre-line',
      },
    },
    content: {
      content:
        'Looking for a sexual health clinic that provides confidential & professional care? At LIPS Clinic, located at Battersea Power Station, we strive to ensure that sexual health is not only about the testing and treatment of sexually transmitted infections (STIs), but also about promoting overall sexual well-being. We understand that sexual health is a crucial aspect of our overall well-being, yet it\'s often a topic that is overlooked or misunderstood. That\'s why we designed our services to support individuals and couples in understanding and improving their sexual health in every aspect.\n\n<span id="more-than-test"></span>\n\n### More Than Test and Treat\n\n While STI testing and treatment are essential components of sexual health, they are just one part of a much broader picture. Sexual health encompasses a variety of factors including sexual function, pleasure, and relationships. At LIPS Clinic, we offer a range of services to address these needs, including support for sexual function issues, such as difficulties with erections or ejaculation. We also provide consultations on relationships, sexual desire, pleasure, and orgasm, ensuring that all aspects of sexual well-being are considered. \n\n<span id="hiv-testing"></span>\n\n### HIV Testing, Treatment, and U=U\n\n HIV testing and treatment are critical aspects of sexual health care. At LIPS, we offer routine HIV testing and the most up-to-date treatment options. It\'s important to note the groundbreaking message of U=U—undetectable equals untransmittable. This means that if a person with HIV is on effective treatment and has an undetectable viral load, they cannot transmit HIV to their partner. This is a game-changer in HIV prevention and is part of the comprehensive care that we offer at LIPS Clinic. \n\n<span id="sti-prevention"></span>\n\n### STI Prevention and Vaccinations\n\n In addition to treatment, prevention is key. LIPS Clinic provides preventative services including vaccinations for diseases like Hepatitis B and HPV. We also offer PrEP (pre-exposure prophylaxis), a medication that significantly reduces the risk of acquiring HIV. Newer options, like injectable PrEP, are also available at our clinic for those who prefer an alternative to daily pills. \n\n<span id="saturday-clinic"></span>\n\n### Saturday Clinic: Accessible Care for Everyone\n\n We understand how busy life can get, which is why LIPS Clinic is open on Saturdays, ensuring that you have convenient access to the sexual health services you need, when you need them. Whether it\'s for testing, treatment, prevention, or general sexual health advice, our clinic is here to support you. \n\n At LIPS Clinic, sexual health is about more than just treatment, it\'s about ensuring you feel empowered, informed, and confident in your sexual well-being. We invite you to visit us and take control of your sexual health today. \n\nIf you need to schedule an appointment or learn more about our services, don\'t hesitate to reach out. Our team is here to help you on your journey to better sexual health.',
      styles: {
        h3: 'text-lg md:text-xl font-bold text-theme-primary mb-4',
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
        a: 'font-semibold text-text-action',
        ul: 'list-disc pl-6 space-y-2 mb-4',
        ol: 'list-decimal pl-6 space-y-3 mb-6',
        li: 'text-text-default leading-relaxed',
        strong: 'font-bold text-theme-primary',
      },
    },
  },
];
